import { useEffect } from "react";
import { getTotalPackingCost } from "@/lib/calc-packing";
import {
  RURAL_SURCHARGE_SGD,
  DIRECT_SIGNATURE_CHARGE_SGD,
} from "@/lib/constants";
import AIReview from "@/features/create-shipment/review/ai-review";

export default function Review({ formData, setFormData, setIsError }) {
  const totalPackingCost = getTotalPackingCost(formData.packages);
  const {
    initialFreightQuote,
    initialDiscountAmount,
    initialValentinesAmount,
    dutiesPaidBy,
    taxes,
    duties,
    dutyHandlingFee,
    insuranceAmount,
    isInsured,
    directSignature,
    isRural,
  } = formData;
  const totalAmount =
    parseFloat(initialFreightQuote) +
    (dutiesPaidBy == "SENDER"
      ? dutyHandlingFee + parseFloat(taxes) + parseFloat(duties)
      : 0) +
    parseFloat(totalPackingCost) +
    (isInsured ? parseFloat(insuranceAmount) : 0) +
    (directSignature ? DIRECT_SIGNATURE_CHARGE_SGD : 0) +
    (isRural ? RURAL_SURCHARGE_SGD : 0) -
    initialDiscountAmount +
    initialValentinesAmount;

  useEffect(() => {
    setFormData({
      ...formData,
      totalPackingCost,
      totalAmount: totalAmount.toFixed(2),
    });
  }, []);

  return (
    <AIReview
      formData={formData}
      setIsError={setIsError}
      setFormData={setFormData}
    />
  );
}
